import React from 'react';

import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link';

const alphabet = [
    `A`,
    `B`,
    `C`,
    `D`,
    `E`,
    `F`,
    `G`,
    `H`,
    `I`,
    `J`,
    `K`,
    `L`,
    `M`,
    `N`,
    `O`,
    `P`,
    `Q`,
    `R`,
    `S`,
    `T`,
    `U`,
    `V`,
    `W`,
    `X`,
    `Y`,
    `Z`,
];

const AlphabetChooser = ({ onClick, spacing=2 }) => {

    const handleClick = (event, letter) => {
        event.preventDefault();
        onClick(letter)
    }

    return (
        <Grid container spacing={spacing}>
            {
                alphabet.map(letter => {
                    return <Grid item key={letter}><Link onClick={event => handleClick(event, letter)} href='#' color="primary"><strong>{letter}</strong></Link></Grid>;
                })
            }
        </Grid>
    );
};

export default AlphabetChooser;